'use client'

import { usePostHog } from 'posthog-js/react'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { usePostHogAuth } from '@/hooks/usePostHogAuth'
import { useErrorTracking } from '@/hooks/useErrorTracking'
import { usePerformanceTracking } from '@/hooks/usePerformanceTracking'

export default function PostHogPageView(): null {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()

  // Handle user identification
  usePostHogAuth()

  // Enable error tracking
  useErrorTracking()

  // Enable performance tracking
  usePerformanceTracking()

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`
      }
      posthog.capture('$pageview', {
        $current_url: url,
        page_path: pathname,
        search_params: searchParams.toString(),
        device_type: window.innerWidth < 768 ? 'mobile' : 'desktop',
        viewport_width: window.innerWidth,
        viewport_height: window.innerHeight,
        timestamp: new Date().toISOString()
      })
    }
  }, [pathname, searchParams, posthog])

  return null
}